import { useCallback, useState } from 'react';
import { useGraphQLClient } from 'studio5/contexts';
import { AGENT_MEMORY } from 'studio5/components/Navigation/queries';

type AgentMemoryData = {
  agentMemory: {
    id: string;
    ownerId: string;
    content: string;
    updatedAt: string;
  } | null;
};

export function useAgentMemory() {
  const client = useGraphQLClient();
  const [memoryContent, setMemoryContent] = useState<string | null>(null);
  const [memoryUpdatedAt, setMemoryUpdatedAt] = useState<string | null>(null);
  const [memoryFetching, setMemoryFetching] = useState(false);

  const fetchMemory = useCallback(() => {
    setMemoryFetching(true);
    client
      .query<AgentMemoryData>(
        AGENT_MEMORY,
        {},
        { requestPolicy: 'network-only' }
      )
      .toPromise()
      .then(result => {
        setMemoryContent(result.data?.agentMemory?.content ?? null);
        setMemoryUpdatedAt(result.data?.agentMemory?.updatedAt ?? null);
      })
      .catch(() => {
        setMemoryContent(null);
        setMemoryUpdatedAt(null);
      })
      .finally(() => {
        setMemoryFetching(false);
      });
  }, [client]);

  return {
    memoryContent,
    memoryUpdatedAt,
    memoryFetching,
    fetchMemory,
  };
}
